import { Component, Input, SimpleChanges } from '@angular/core';
import { BatteryTypeOption, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-soc-end-chart',
  templateUrl: './soc-end-chart.component.html',
  styleUrls: ['./soc-end-chart.component.scss']
})
export class SocEndChartComponent {
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  @Input() dataLoadingSoc!: boolean;
  @Input() errorMessageSoc!: boolean;
  @Input() stateOfChargeDatapoints!: any;
  chartRange!: { range: [number, number]; };
  
  ngOnChanges(changes: SimpleChanges): void {
    if (Object.keys(this.stateOfChargeDatapoints).length !== 0) {
      this.plotSocEndChart();
    }
  }
  
  plotSocEndChart() {
    const transformXAxisPipe = new TransformXAxisPipe();

    const data = toBatteryTypeSeries(this.stateOfChargeDatapoints, this.selectedBatteryTypes).map((series) => {
      const filteredData = series.datapoints.filter((dataObject: any) => dataObject.chargingSessionsEnd !== null);
      return {
        x: filteredData.map((dataObject: any) => dataObject.binSoc),
        y: filteredData.map((dataObject: any) => dataObject.chargingSessionsEnd),
        type: 'bar',
        name: series.label,
        marker: {
          color: series.color
        }
      };
    });

    const endSoc = data.flatMap((trace) => trace.x);
    const percentAmount = data.flatMap((trace) => trace.y);

    if (percentAmount.length === 0) {
      this.errorMessageSoc = true;
      return;
    } else {
      this.errorMessageSoc = false;
    }

    this.chartRange = transformXAxisPipe.transform(endSoc, percentAmount, 5, 100);

    const layout = {
      title: 'End State of Charge',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'End State of Charge [%]',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Charging Sessions [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h',
        y: -0.3,
        xanchor: 'center',
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };

    createPlotlyChart('soc-end-chart', data, layout);
  }
  
}